import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0dd39bd0")

_pushScopeId("data-v-0dd39bd0")
const _hoisted_1 = { class: "h-screen" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 印刷 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-gray-500 hidden md:block" }, " ※画像のダウンロードは右クリックの後「名前をつけて保存」をしてください。 ", -1)
const _hoisted_5 = { class: "flex flex-col md:flex-row items-center" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { class: "text-xl ml-4" }
const _hoisted_13 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_14 = {
  key: 1,
  class: "ml-4"
}
const _hoisted_15 = { class: "flex items-center mt-2 md:ml-4 md:mt-0" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 確認済にする ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 再提出にする ")
const _hoisted_18 = {
  key: 0,
  class: "w-full mt-4"
}
const _hoisted_19 = { class: "flex items-center mb-2 flex-row" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text-sm font-medium mx-2" }, "生徒からのコメント", -1)
const _hoisted_21 = { class: "w-full mt-4" }
const _hoisted_22 = {
  key: 0,
  class: "w-full p-3 rounded-md border flex items-center text-yellow-400"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm font-medium" }, "提出された画像がありません", -1)
const _hoisted_24 = { class: "print-visible mb-2" }
const _hoisted_25 = {
  key: 1,
  class: "w-full p-3 rounded-md border-4 border-gray-300 text-sm font-normal text-yellow-300 flex"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "text-gray-500 font-medium" }, " この画像は削除されています ", -1)
const _hoisted_27 = {
  key: 1,
  class: "w-full mt-4"
}
const _hoisted_28 = { class: "mb-2" }
const _hoisted_29 = { class: "text-black" }
const _hoisted_30 = {
  key: 0,
  className: "fixed right-0 top-0 print-hidden hidden lg:block w-1/4 z-0 h-full bg-primary-100 border-l-4 border-primary-100 overflow-hidden lg:overscroll-auto"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MSMessagePanel = _resolveComponent("MSMessagePanel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: _ctx.useMessagePanel ? 'lg:w-3/4' : ''
    }, [
      _createVNode("div", {
        class: ["p-4 bg-white print-hidden border-b-4 border-primary-100 fixed w-full", _ctx.useMessagePanel ? 'lg:w-3/4' : '']
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_m_button, {
            class: "mr-4",
            color: "primary-500",
            "hover-color": "primary-600",
            onClick: _ctx.print
          }, {
            default: _withId(() => [
              _createVNode(_component_m_icon, {
                type: "printer",
                class: "mr-2"
              }),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_4
        ])
      ], 2),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataMaps, (dataMap) => {
        return (_openBlock(), _createBlock("div", {
          id: dataMap.data.uid,
          key: dataMap.data.uid,
          class: "m-4 mt-0 pt-24 print:pt-0 pb-16"
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", {
                class: ["text-sm px-2 py-1 border rounded shrink-0", {
                'border-gray-400':
                  dataMap.data.status === 'unsubmitted' ||
                  dataMap.data.status === 'rejected_unsubmitted',
                'text-gray-400':
                  dataMap.data.status === 'unsubmitted' ||
                  dataMap.data.status === 'rejected_unsubmitted',
                'border-red-400':
                  dataMap.data.status === 'submitted' ||
                  dataMap.data.status === 'rejected_submitted',
                'text-red-400':
                  dataMap.data.status === 'submitted' ||
                  dataMap.data.status === 'rejected_submitted',
                'border-green-500': dataMap.data.status === 'fulfilled',
                'text-green-500': dataMap.data.status === 'fulfilled'
              }]
              }, [
                (dataMap.data.status === 'unsubmitted')
                  ? (_openBlock(), _createBlock("span", _hoisted_7, "実施中"))
                  : _createCommentVNode("", true),
                (dataMap.data.status === 'submitted')
                  ? (_openBlock(), _createBlock("span", _hoisted_8, "確認待ち"))
                  : _createCommentVNode("", true),
                (dataMap.data.status === 'rejected_unsubmitted')
                  ? (_openBlock(), _createBlock("span", _hoisted_9, "再提出 : 実施中"))
                  : _createCommentVNode("", true),
                (dataMap.data.status === 'rejected_submitted')
                  ? (_openBlock(), _createBlock("span", _hoisted_10, "再提出 : 確認待ち"))
                  : _createCommentVNode("", true),
                (dataMap.data.status === 'fulfilled')
                  ? (_openBlock(), _createBlock("span", _hoisted_11, "確認済"))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("h1", _hoisted_12, _toDisplayString(dataMap.submissionMasterData?.name), 1),
              (dataMap.studentData)
                ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(dataMap.studentData.name), 1))
                : _createCommentVNode("", true),
              (dataMap.data.submittedAt > 0)
                ? (_openBlock(), _createBlock("time", _hoisted_14, _toDisplayString(_ctx.toTimeString(dataMap.data.submittedAt)), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                class: "print-hidden",
                disabled: 
                dataMap.data.status === 'unsubmitted' ||
                dataMap.data.status === 'rejected_unsubmitted' ||
                dataMap.data.status === 'fulfilled'
              ,
                onClick: ($event: any) => (_ctx.setSubmissionStatus(dataMap, 'fulfilled'))
              }, {
                default: _withId(() => [
                  _createVNode(_component_m_icon, {
                    type: "check",
                    width: "4",
                    class: "mr-2"
                  }),
                  _hoisted_16
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_m_button, {
                color: "secondary-500",
                "hover-color": "secondary-600",
                class: "ml-4 print-hidden",
                disabled: 
                dataMap.data.status === 'unsubmitted' ||
                dataMap.data.status === 'rejected_unsubmitted'
              ,
                onClick: ($event: any) => (_ctx.setSubmissionStatus(dataMap, 'rejected_unsubmitted'))
              }, {
                default: _withId(() => [
                  _createVNode(_component_m_icon, {
                    type: "refresh",
                    width: "2",
                    class: "mr-2"
                  }),
                  _hoisted_17
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          (dataMap.data.comment)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("img", {
                    src: _ctx.icon,
                    alt: "生徒",
                    class: "w-8 h-8 rounded-full"
                  }, null, 8, ["src"]),
                  _hoisted_20
                ]),
                _createVNode("div", {
                  class: ["p-4 bg-gray-100 text-sm rounded whitespace-pre-wrap break-words mr-3 ml-10", {
              'page-break-after-always': _ctx.isLongComment(dataMap.data.comment)
            }]
                }, _toDisplayString(dataMap.data.comment), 3)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_21, [
            (dataMap.data.imageUrls.length === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_22, [
                  _createVNode(_component_m_icon, {
                    type: "warning",
                    size: "6",
                    class: "mr-2"
                  }),
                  _hoisted_23
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataMap.data.imageUrls, (url, uIndex) => {
              return (_openBlock(), _createBlock("div", {
                key: url,
                class: "mb-4"
              }, [
                _createVNode("div", _hoisted_24, _toDisplayString(dataMap.studentData?.name) + "【" + _toDisplayString(uIndex + 1) + " / " + _toDisplayString(dataMap.data.imageUrls.length) + "】 ", 1),
                (!_ctx.imageUrlsRequiringAltDisplay.includes(url))
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: url,
                      class: "image page-break-after-always",
                      onError: ($event: any) => (_ctx.setAltImage(url))
                    }, null, 40, ["src", "onError"]))
                  : _createCommentVNode("", true),
                (_ctx.imageUrlsRequiringAltDisplay.includes(url))
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      _createVNode(_component_m_icon, {
                        type: "warning",
                        size: "6",
                        class: "mr-2"
                      }),
                      _hoisted_26
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (dataMap.data.fileUrls.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, _toDisplayString(dataMap.studentData?.name) + "【 画像以外の提出ファイル 】 ", 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataMap.data.fileDataList, (fileData) => {
                  return (_openBlock(), _createBlock("div", {
                    key: fileData.url,
                    class: "my-2"
                  }, [
                    _createVNode("a", {
                      href: fileData.url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "p-3 rounded-md border flex items-center text-sm font-medium text-primary-500"
                    }, [
                      _createVNode(_component_m_icon, {
                        type: fileData.contentIconType,
                        width: "0.7",
                        size: "8",
                        class: "mr-2"
                      }, null, 8, ["type"]),
                      _createVNode("span", _hoisted_29, _toDisplayString(fileData.contentTypeToDisplay) + " (" + _toDisplayString(fileData.sizeString) + ")", 1)
                    ], 8, ["href"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 8, ["id"]))
      }), 128))
    ], 2),
    (_ctx.useMessagePanel)
      ? (_openBlock(), _createBlock("section", _hoisted_30, [
          _createVNode(_component_MSMessagePanel)
        ]))
      : _createCommentVNode("", true)
  ]))
})